<template>
  <div class="d-flex justify-content-center">
    <div v-if="isAdmin">
      <div class="sticky">
        <h1 class="text-center">СДАТЧИКИ</h1>
        <input
          type="text"
          class="form-control w-100 center"
          placeholder="Поиск"
          v-model="searchText"
          @input="search"
        />
      </div>
      <div class="main-content">
        <div v-if="!loading" class="container">
          <div
            v-for="(user, index) in usersFilter"
            :key="user._id"
            class="card lh-1 mb-3"
            style="max-width: 400px"
          >
            <div class="card-body">
              <form @submit="saveUser(user, index, $event)">


                <div class="row row-cols-2 mt-2">
                  <div class="col text-muted"><small>Фамилия</small></div>
                  <div class="col text-muted"><small>Имя</small></div>
                  <div class="col">
                    <input
                      v-if="user.edit"
                      class="form-control p-1"
                      v-model="user.passport.lastName"
                      type="text"
                      required
                    />
                    <span v-else>{{ user.passport.lastName }}</span>
                  </div>
                  <div class="col">
                    <input
                      v-if="user.edit"
                      class="form-control p-1"
                      v-model="user.passport.firstName"
                      type="text"
                      
                    />
                    <span v-else>{{ user.passport.firstName }}</span>
                  </div>
                </div>

                <div class="row row-cols-1 mt-2">
                  <div class="col text-muted"><small>Отчество</small></div>
                  <div class="col">
                    <input
                      v-if="user.edit"
                      class="form-control p-1"
                      v-model="user.passport.middleName"
                      type="text"
                      
                    />
                    <span v-else>{{ user.passport.middleName }}</span>
                  </div>
                </div>

                <div class="row row-cols-2 mt-2">
                  <div class="col text-muted">
                    <small>Номер паспорта</small>
                  </div>
                  <div class="col text-muted">
                    <small>Дата выдачи паспорта</small>
                  </div>
                  <div class="col">
                    <input
                      v-if="user.edit"
                      class="form-control p-1"
                      v-model="user.passport.docNumber"
                      type="text"
                      
                    />
                    <span v-else>{{ user.passport.docNumber }}</span>
                  </div>
                  <div class="col">
                    <input
                      class="form-control p-1"
                      v-model="user.passport.docIssueDate"
                      type="date"
                      
                      :disabled="!user.edit"
                    />
                  </div>
                </div>

                <div class="row row-cols-2 mt-2">
                  <div class="col text-muted"><small>Дата рождения</small></div>
                  <div class="col text-muted"><small>Гражданство</small></div>
                  <div class="col">
                    <input
                      class="form-control p-1"
                      v-model="user.passport.birthDate"
                      type="date"
                      
                      :disabled="!user.edit"
                    />
                  </div>
                  <div class="col">
                    <select
                      v-model="user.passport.country"
                      :disabled="!user.edit"
                      class="form-select"
                    >
                      <option value="643">Россия</option>
                      <option value="112">Беларусь</option>
                      <option value="804">Украина</option>
                    </select>
                  </div>
                </div>

                <div class="row row-cols-2 mt-2">
                  <div class="col text-muted"><small>Город</small></div>
                  <div class="col text-muted">
                    <small>Почтовый индекс</small>
                  </div>
                  <div class="col">
                    <input
                      v-if="user.edit"
                      class="form-control p-1"
                      v-model="user.passport.city"
                      type="text"
                      
                    />
                    <span v-else>{{ user.passport.city }}</span>
                  </div>
                  <div class="col">
                    <input
                      v-if="user.edit"
                      class="form-control p-1"
                      v-model="user.passport.postcode"
                      type="number"
                      
                    />
                    <span v-else>{{ user.passport.postcode }}</span>
                  </div>
                </div>

                <div class="row row-cols-1 mt-2">
                  <div class="col text-muted"><small>Адрес</small></div>
                  <div class="col">
                    <input
                      v-if="user.edit"
                      class="form-control p-1"
                      v-model="user.passport.address"
                      type="text"
                      
                    />
                    <span v-else>{{ user.passport.address }}</span>
                  </div>
                </div>

                <div class="row row-cols-2 mt-2">
                  <div class="col text-muted">
                    <small>Разворот 1 и 2 страницы</small>
                  </div>
                  <div class="col text-muted"><small>Прописка</small></div>
                  <div
                    class="col"
                    v-if="user.passportImg && user.passportImg.main.img"
                  >
                    <a
                      :download="user.passportImg.main.fileName"
                      :href="`data:${user.passportImg.main.mimetype};base64,${user.passportImg.main.img}`"
                    >
                      <img
                        class="w-100"
                        :src="`data:${user.passportImg.main.mimetype};base64,${user.passportImg.main.img}`"
                      />
                    </a>
                  </div>
                  <div
                    class="col"
                    v-if="user.passportImg && user.passportImg.address.img"
                  >
                    <a
                      :download="user.passportImg.address.fileName"
                      :href="`data:${user.passportImg.address.mimetype};base64,${user.passportImg.address.img}`"
                    >
                      <img
                        class="w-100"
                        :src="`data:${user.passportImg.address.mimetype};base64,${user.passportImg.address.img}`"
                      />
                    </a>
                  </div>
                </div>

                <div class="row row-cols-2 mt-2">
                  <div class="col text-muted"><small>Email</small></div>
                  <div class="col text-muted"><small>Телефон</small></div>
                  <div class="col">
                    <input
                      v-if="user.edit"
                      class="form-control p-1"
                      v-model="user.email"
                      type="email"
                      required
                    />
                    <span v-else>{{ user.email }}</span>
                  </div>
                  <div class="col">
                    <div v-if="user.edit" class="input-group">
                      <span class="input-group-text p-1" id="basic-addon1"
                        >+7</span
                      >
                      <input
                        id="phone"
                        class="form-control p-1"
                        v-model="user.phone"
                        type="tel"
                        pattern="[0-9]{10}"
                        
                        placeholder="1234567890"
                      />
                    </div>
                    <span v-else>+7{{ user.phone }}</span>
                  </div>
                </div>

                <div class="row row-cols-3 mt-2">
                  <div class="col">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`flexSwitchActive-${user._id}`"
                        v-model="user.active"
                        :disabled="!user.edit"
                      />
                      <label
                        class="form-check-label"
                        :for="`flexSwitchActive-${user._id}`"
                        ><small>Email подтвержден</small></label
                      >
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`flexSwitchChecked-${user._id}`"
                        v-model="user.checked"
                        :disabled="!user.edit"
                      />
                      <label
                        class="form-check-label"
                        :for="`flexSwitchChecked-${user._id}`"
                        ><small>Паспорт проверен</small></label
                      >
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`flexSwitchHostel-${user._id}`"
                        v-model="user.hostel"
                        :disabled="!user.edit"
                      />
                      <label
                        class="form-check-label"
                        :for="`flexSwitchHostel-${user._id}`"
                        ><small>Сборщик общ</small></label
                      >
                    </div>
                  </div>
                </div>

                <div class="row row-cols-1 mt-2">
                  <div class="col">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="`flexSwitchPassword-${user._id}`"
                        v-model="user.setPassword"
                        :disabled="!user._id"
                      />
                      <label
                        class="form-check-label"
                        :for="`flexSwitchPassword-${user._id}`"
                        ><small>Новый пароль</small></label
                      >
                    </div>
                    <input
                      v-if="user.setPassword"
                      class="form-control p-1"
                      v-model="user.password"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div class="row row-cols-1 mt-2">
                  <div class="col text-muted"><small>БОНУС</small></div>
                  <div class="col">
                    <input
                      v-if="user.edit"
                      class="form-control p-1"
                      v-model="user.bonus"
                      type="number"
                    />
                     <input v-else
                      class="form-control p-1 font-weight-bold"
                      v-model="user.bonus"
                      type="number"
                      disabled
                    />
                  </div>
                </div>

                <div class="row row-cols-1 mt-2">
                  <div class="col text-muted">
                    <small>Идентификатор 1С (guid1C)</small>
                  </div>

                  <input
                    :disabled="!user.edit"
                    class="form-control p-1 font-weight-bold"
                    v-model="user.guid1C"
                    type="text"
                  />
                </div>

                <div class="row row-cols-1 pt-2">
                  <div class="col pt-1 btn-group">
                    <button
                      type="submit"
                      class="btn btn-light w-100"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Сохранить данные пользователя"
                    >
                      <font-awesome-icon icon="save" />
                      <div
                        v-if="user.loadingSave"
                        class="spinner-border"
                        role="status"
                      >
                      </div>
                    </button>

                    <button
                      @click.prevent="user.edit = user.edit ? false : true"
                      class="btn btn-light w-100"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Редактировать данные пользователя"
                    >
                      <font-awesome-icon icon="user-edit" />
                    </button>

                    <button
                      class="btn btn-light w-100"
                      data-bs-toggle="modal"
                      :data-bs-target="`#remove-user-confirm-${user._id}`"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Удалить пользователя"
                      type="button"
                    >
                      <font-awesome-icon icon="trash" />
                    </button>
                    <!-- Modal -->
                    <div
                      class="modal fade"
                      :id="`remove-user-confirm-${user._id}`"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">
                              Внимание!
                            </h5>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div class="modal-body">
                            Вы действительно хотите удалить пользователя "{{
                              `${user.passport.lastName} ${user.passport.firstName} ${user.passport.middleName} `
                            }}"?
                          </div>
                          <div class="modal-footer">
                            <button
                              type="button"
                              class="btn btn-secondary"
                              data-bs-dismiss="modal"
                            >
                              Нет
                            </button>
                            <button
                              type="button"
                              class="btn btn-danger"
                              data-bs-dismiss="modal"
                              @click="removeUser(user)"
                            >
                              Да
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div v-if="loading" class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { ref, computed, onMounted } from "vue";
import useCommonMixin from "@/components/commonMixin.js";

export default {
  name: "UsersDelivery",
  setup() {
    const store = useStore();
    const users = ref([]);
    const { asyncForEach, isAdmin } = useCommonMixin();
    const loading = ref(true);
    const searchText = ref("");

    const init = async () => {
      loading.value = true;
      let response = await store.dispatch("FETCHuser", "deliverer");
      users.value = response.status ? response.data : [];
      asyncForEach(users.value, async (user) => {
        user.phone = user.phone.slice(2, 12);
        user.passport.birthDate = user.passport.birthDate
          ? user.passport.birthDate.slice(0, 10)
          : "";
        user.passport.docIssueDate = user.passport.docIssueDate
          ? user.passport.docIssueDate.slice(0, 10)
          : "";
        user.passportImg = {
          main: {
            img: null,
            fileName: "main",
            mimetype: "",
          },
          address: {
            img: null,
            fileName: "main",
            mimetype: "",
          },
        };
        let passpMainPage = await store.dispatch("FETCHpassportImg", {
          page: "main",
          userId: user._id,
        });
        if (passpMainPage.status) {
          user.passportImg.main = passpMainPage.data;
        }

        let passpAddressPage = await store.dispatch("FETCHpassportImg", {
          page: "address",
          userId: user._id,
        });
        if (passpAddressPage.status) {
          user.passportImg.address = passpAddressPage.data;
        }
      });
      loading.value = false;
    };

    const saveUser = async (user, userIndex, event) => {
      event.preventDefault();
      users.value[userIndex].loadingSave = true;
      const passportImg = user.passportImg
      let response = await store.dispatch("POSTuser", user);
      if (response.status) {
        users.value[userIndex]._id = response.data.message._id;
        users.value[userIndex].edit = false;
        users.value[userIndex].setPassword = false;
      }
      user.passportImg = passportImg
      users.value[userIndex].loadingSave = false;
      //console.log(response);
      //init();
    };

    const removeUser = async (user) => {
      user.delete = true;
      let remove = await store.dispatch("POSTuser", user);
      user.delete = remove.status ? true : false;
    };

    const usersFilter = computed(() => {
      let result = [];
      if (searchText.value.length >= 2) {
        result = users.value.filter((user) => {
          return (
            JSON.stringify(user)
              .toLowerCase()
              .indexOf(searchText.value.toLowerCase()) >= 0 && !user.delete
          );
        });
      } else {
        result = users.value.filter((user) => !user.delete);
      }
      return result;
    });

    onMounted(init);
    return {
      users,
      loading,
      saveUser,
      removeUser,
      isAdmin,
      usersFilter,
      searchText,
    };
  },
};
</script>

<style>
</style>